import { render } from "./PanelIndex.vue?vue&type=template&id=cb1feef2&scoped=true&ts=true"
import script from "./PanelIndex.vue?vue&type=script&lang=ts"
export * from "./PanelIndex.vue?vue&type=script&lang=ts"

import "./PanelIndex.vue?vue&type=style&index=0&id=cb1feef2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb1feef2"]])

export default __exports__